export enum ClientUpdateRequestType {
    CLEAR_LAYOUT_CACHE = "CLEAR_LAYOUT_CACHE",
    TEMPORARY_LICENSE_CHANGE = "TEMPORARY_LICENSE_CHANGE"
}
